



































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ReferralBoth extends Vue {
  @Prop({ default: '64' }) readonly width?: string;
  @Prop({ default: '65' }) readonly height?: string;
}
